<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" :before-leave="beforeTabLeave">
      <el-tab-pane :label="courseName" name="first">
        <div class="main">
          <!-- Right -->
          <div class="main_r">
            <!-- search -->
           <div class="search">
              <div>
                <el-button type="primary" @click="clickBack">返回</el-button>
                <el-button type="primary" @click="clickQuery">刷新</el-button>
                <el-button type="primary" @click="clickAdd">添加动作到课程</el-button>
              </div>
            </div>
            <!-- search End -->

            <!-- 列表 -->
            <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
              <el-table-column type="expand" min-width="1%">
                <template slot-scope="props">
                  <el-table :data="props.row.list" height="300" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center',padding: '0' }">
                    <el-table-column prop="sort" label="动作参数排序" sortable></el-table-column>
                    <el-table-column prop="parameterType" label="参数类型" sortable>
                      <template slot-scope="props">
                        <span v-if="props.row.parameterType == 1">力量*次数</span>
                        <span v-if="props.row.parameterType == 2">时长</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="power" label="力量" v-if="props.row.calculateType == 1">
                      <template slot-scope="propsSub">
                        {{propsSub.row.power}}Kg
                      </template>
                    </el-table-column>
                    <el-table-column prop="trainDate" label="次数" v-if="props.row.calculateType == 1">
                      <template slot-scope="propsSub">
                        {{propsSub.row.num}}次
                      </template>
                    </el-table-column>
                    <el-table-column prop="completedPercentage" label="时长" v-if="props.row.calculateType == 2">
                      <template slot-scope="props">
                        {{props.row.seconds}}秒
                      </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
                    <el-table-column prop="Operation" label="操作" width="200">
                      <template slot-scope="scope">
                        <el-link :underline="false" type="primary" class="mr12" @click="ClickEditParameter(scope.row)">编辑</el-link>
                        <el-link :underline="false" type="danger" class="mr12" @click="ClickDeleteParameter(scope.row)">删除</el-link>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="sort" label="动作排序" sortable></el-table-column>
              <el-table-column prop="actionName" label="动作名称" sortable></el-table-column>
              <el-table-column prop="" label="动作列表封面" width="120">
                <template v-slot="scope">
                  <img :src="scope.row.actionIcon" min-width="64" height="64" />
                </template>
              </el-table-column>
              <el-table-column prop="calculateType" label="计算类型" sortable>
                <template slot-scope="props">
                  <span v-if="props.row.calculateType == 1">计次</span>
                  <span v-if="props.row.calculateType == 2">计时</span>
                </template>
              </el-table-column>
              <el-table-column prop="numGroup" label="组数" sortable></el-table-column>
              <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
              <el-table-column prop="Operation" label="操作" width="200">
                <template slot-scope="scope">
                  <el-link :underline="false" type="primary" class="mr12" @click="clickdialogEdit(scope.row)">设置动作排序</el-link>
                  <el-link :underline="false" type="danger" class="mr12" @click="ClickDelete(scope.row)">删除动作</el-link>
                  <el-link :underline="false" type="primary" class="mr12" @click="ClickAddParameter(scope.row)">添加动作参数</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- Right End -->
        </div>
      </el-tab-pane>

      <!-- 添加动作到课程 start -->
      <el-tab-pane label="添加动作到课程" name="second">
        <WebTwoCourseActionAdd ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></WebTwoCourseActionAdd>
      </el-tab-pane>
      <!-- 添加动作到课程 end -->

      <!-- 设置动作排序 -->
      <el-dialog title="设置动作排序" :visible.sync="dialogEdit" width="35%" class="newAdd" :close-on-click-modal="false">
        <div class="addUser_body">
          <el-form ref="userMsg" :model="editData" label-width="150px">

            <el-form-item label="动作排序" :required=true>
              <el-input v-model="editData.sort" placeholder="请输入排序"></el-input>
            </el-form-item>

          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CourseActionUpdate()" >确 认</el-button>
          <el-button @click="dialogEdit = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 设置动作排序 End -->

      <!-- 删除 -->
      <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel">
        <div class="confirmMsg">确定删除？</div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CourseActionDelete" >确 定</el-button>
          <el-button @click="dialogDel = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 删除 End -->

      <!-- 添加动作参数 -->
      <el-dialog title="添加动作参数" :visible.sync="dialogAddParameter" width="35%" class="newAdd" :close-on-click-modal="false">
        <div class="addUser_body">
          <el-form ref="userMsg" :model="addDataParameter" label-width="150px">
            <el-form-item label="力量" :required=true v-if="addDataParameter.parameterType == 1">
              <el-input v-model="addDataParameter.power" placeholder="请输入力量">
                <template slot="append">
                  <span style="width: 100px; display: inline-block;text-align: center;">KG</span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="次数" :required=true v-if="addDataParameter.parameterType == 1">
              <el-input v-model="addDataParameter.num" placeholder="请输入次数">
                <template slot="append">
                  <span style="width: 100px; display: inline-block;text-align: center;">次</span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="时长" :required=true v-if="addDataParameter.parameterType == 2">
              <el-input v-model="addDataParameter.seconds" placeholder="请输入时长">
                <template slot="append">
                  <span style="width: 100px; display: inline-block;text-align: center;">秒</span>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CourseActionParameterInsert()" >确 认</el-button>
          <el-button @click="dialogAddParameter = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 添加动作参数 End -->

      <!-- 编辑动作参数 -->
      <el-dialog title="编辑动作参数" :visible.sync="dialogEditParameter" width="35%" class="newAdd" :close-on-click-modal="false">
        <div class="addUser_body">
          <el-form ref="userMsg" :model="editDataParameter" label-width="150px">
            <el-form-item label="动作参数排序" :required=true>
              <el-input v-model="editDataParameter.sort" placeholder="请输入排序"></el-input>
            </el-form-item>
            <el-form-item label="力量" :required=true v-if="editDataParameter.parameterType == 1">
              <el-input v-model="editDataParameter.power" placeholder="请输入力量">
                <template slot="append">
                  <span style="width: 100px; display: inline-block;text-align: center;">KG</span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="次数" :required=true v-if="editDataParameter.parameterType == 1">
              <el-input v-model="editDataParameter.num" placeholder="请输入次数">
                <template slot="append">
                  <span style="width: 100px; display: inline-block;text-align: center;">次</span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="时长" :required=true v-if="editDataParameter.parameterType == 2">
              <el-input v-model="editDataParameter.seconds" placeholder="请输入时长">
                <template slot="append">
                  <span style="width: 100px; display: inline-block;text-align: center;">秒</span>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CourseActionParameterUpdate()" >确 认</el-button>
          <el-button @click="dialogEditParameter = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 编辑动作参数 End -->

      <!-- 删除动作参数 -->
      <el-dialog title="操作确认" :visible.sync="dialogDelParameter" width="20%" class="confirmDel">
        <div class="confirmMsg">确定删除该动作参数？</div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CourseActionParameterDelete" >确 定</el-button>
          <el-button @click="dialogDelParameter = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 删除动作参数 End -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import WebTwoCourseActionAdd from '@/componentsSubVue/WebTwoCourseActionAdd.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    WebTwoCourseActionAdd
  },
  data () {
    return {
      activeName: 'first',
      courseId: '0',
      courseName: '',
      // 列表
      dataList: [],
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        sort: ''
      },
      // 删除
      deleteForm: {
        id: ''
      },
      dialogDel: false,
      // 新增参数
      dialogAddParameter: false,
      addDataParameter: {
        sort: '',
        courseActionId: '',
        parameterType: '',
        power: '',
        num: '',
        seconds: ''
      },
      // 编辑参数
      dialogEditParameter: false,
      editDataParameter: {
        sort: '',
        courseActionId: '',
        parameterType: '',
        power: '',
        num: '',
        seconds: '',
        id: ''
      },
      // 删除参数
      deleteFormParameter: {
        id: ''
      },
      dialogDelParameter: false,
      allowChangeTab: false,
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.courseId = row.id
      this.courseName = "【"+row.courseName+"】的动作列表"
      this.CourseActionList()
    },
    BackToFirst (val) {
      this.activeName = 'first'
      this.CourseActionList()
    },
    clickQuery () {
      this.CourseActionList()
    },
    beforeTabLeave(activeName, oldActiveName) {
      if (!this.allowChangeTab && activeName !== "first") {
        this.$message.warning('禁止点击');
        return false;
      }
      this.allowChangeTab = false;
      return true;
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clickAdd() {
      this.allowChangeTab = true;
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(this.courseId)
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.sort = row.sort
    },
    ClickDelete (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    ClickAddParameter(row){
      this.dialogAddParameter = true
      this.addDataParameter.sort = '0'
      this.addDataParameter.courseActionId = row.id
      this.addDataParameter.parameterType = row.calculateType
      this.addDataParameter.power = '0'
      this.addDataParameter.num = '0'
      this.addDataParameter.seconds = '0'
      console.log(this.addDataParameter)
    },
    ClickEditParameter(row){
      this.dialogEditParameter = true
      this.editDataParameter.sort = row.sort
      this.editDataParameter.courseActionId = row.courseActionId
      this.editDataParameter.parameterType = row.parameterType
      this.editDataParameter.power = row.power
      this.editDataParameter.num = row.num
      this.editDataParameter.seconds = row.seconds
      this.editDataParameter.id = row.id
    },
    ClickDeleteParameter(row){
      this.dialogDelParameter = true
      this.deleteFormParameter.id = row.id
    },
    CourseActionList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.courseId = that.courseId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    CourseActionUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.sort = that.editData.sort
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    CourseActionDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
          }
          that.dialogDel = false
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    },
    CourseActionParameterInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sort = that.addDataParameter.sort
      data.courseActionId = that.addDataParameter.courseActionId
      data.parameterType = that.addDataParameter.parameterType
      data.power = that.addDataParameter.power
      data.num = that.addDataParameter.num
      data.seconds = that.addDataParameter.seconds
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionParameterInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
            that.dialogAddParameter = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAddParameter = false
        })
    },
    CourseActionParameterUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editDataParameter.id
      data.sort = that.editDataParameter.sort
      data.courseActionId = that.editDataParameter.courseActionId
      data.parameterType = that.editDataParameter.parameterType
      data.power = that.editDataParameter.power
      data.num = that.editDataParameter.num
      data.seconds = that.editDataParameter.seconds
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionParameterUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
            that.dialogEditParameter = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    CourseActionParameterDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteFormParameter.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionParameterDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
            that.dialogDelParameter = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDelParameter = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }

}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
